import { render, staticRenderFns } from "./ItemModal.vue?vue&type=template&id=663566e2"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports